import { memo } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { CloseOutlined } from "@ant-design/icons";
import classname from "classname";

const Reject = ({
  id,
  title,
  icon = <CloseOutlined />,
  type = "primary",
  disabled = false,
  btnClassName,
  ...props
}) => {
  const { t } = useTranslation();
  const btnTitle = title ? title : t("button.decline");
  return (
    <Button
      className={classname(
        `border-0 justify-center items-center flex hover:opacity-70 ${btnClassName}`,
        {
          "bg-red1": !disabled,
        }
      )}
      id={id}
      type={type}
      icon={icon}
      disabled={disabled}
      {...props}
    >
      {btnTitle}
    </Button>
  );
};

export default memo(Reject);
